import '../game.css';
const React = require('react');
const { CircleIndicator } = require('react-indicators');
const { DragSource, DragPreviewImage } = require('react-dnd');
const dragType = require('../../../define/dragType').default;
const player = require('../../../define/player').default;
const assets = require('../../../assets').default;
const style = require('../game.style').default;

/*
    props:
    playerCharactor: player.PLAYER_SAMMONER,
    playerName: "",
    playerSkill: null,
    playerSkillName: "",
    playerSkillCoolTime: 0,
    playerSkillArea: [],
    playerSkillDamage: 0,
    baseTime: undefined,
    startedAt: undefined,
    stoppedAt: undefined,
*/
// ============================
const dragSpec = {
    beginDrag(props) {
        const { state: { playerSkillArea, playerSkillDamage } } = props;
        return { playerSkillArea, playerSkillDamage };
    },
    canDrag(props) {
        const { state: { canSkill } } = props;
        return canSkill
    },
}

function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging()
    }
}

const OverlayPanel = ({ color, children }) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 10,
                opacity: 0.5,
                backgroundColor: color,
            }}
        >
            {children}
        </div>
    )
}

const Panel = (type) => {
    let imageSrc = undefined;
    switch (type) {
        case player.PLAYER_ROYAL_GUARD:
            imageSrc = assets.SkillPanelRG;
            break;
        case player.PLAYER_KAGEROU:
            imageSrc = assets.SkillPanelKG;
            break;
        case player.PLAYER_SUMMONER:
            imageSrc = assets.SkillPanelSM;
            break;
        default:
            break;
    }
    return (
        <>
            {imageSrc && <img src={imageSrc} className="selector-player-img" />}
        </>
    );
}

class playerComponent extends React.Component {
    renderPlayer() {
        const { state: { playerCharactor, canSkill, playerSkillCoolTime }, skillRemainingTime } = this.props;
        const progress = skillRemainingTime / playerSkillCoolTime;
        return (
            <div className="selector-player">
                {!canSkill &&
                    <OverlayPanel color="gray" >
                        <CircleIndicator size={style.selectorSlotSize} progress={progress} strokeWidth={5} />
                    </OverlayPanel>
                }
                {Panel(playerCharactor)}
            </div>
        )
    }

    render() {
        const opacity = this.props.isDragging ? 0.4 : 1;
        return (
            <>
                <DragPreviewImage connect={this.props.connectDragPreview} src={assets.IconSkillTarget} />
                <div ref={this.props.connectDragSource} style={{ opacity }}> {this.renderPlayer()}</div >
            </>
        )
    }
}

export default DragSource(dragType.SKILL, dragSpec, collect)(playerComponent);